export default __webpack_public_path__ + "static/media/gradle.625b5f58.png";